<template>
    <div class="tasks-card card mx-1">
        <div class="card-header">
            <h3 class="mb-0">Action Items</h3>
        </div>

        <div class="card-body">
            <div class="tasks">
                <div class="row" v-for="(task, index) in lockstepStore.tasks" :key="`task-${index}-${task.id}`">
                    <div class="col-auto">
                        <transition name="task-icon" mode="out-in">
                            <!-- Completed icon/button -->
                            <button class="btn btn-icon-only-md btn-white" v-if="task.is_completed"
                                @click="unmarkTask(task)" key="completed" data-bs-toggle="tooltip" title="Mark as incomplete">
                                <img src="/img/icons/avid-icons/check-circle.svg" class="task-icon-completed" alt="">
                            </button>

                            <!-- Incomplete icon/button -->
                            <button
                                class="btn btn-icon-only-md btn-white"
                                v-else
                                @click="completeTask(task)"
                                key="todo"
                                data-bs-toggle="tooltip"
                                title="Mark as complete"
                            >
                                <img src="/img/icons/avid-icons/square.svg" class="task-icon-todo" alt="">
                            </button>
                        </transition>
                    </div>
                    <div class="col">
                        <div class="task mt-2">
                            <!-- First row: task name and button -->
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <h6 class="mb-0">{{ task.name }}</h6>
                                <span v-if="task.due_at" class="text-muted ms-2 small d-none d-sm-block d-lg-none d-xl-block">Due: {{ date(task.due_at)
                                    }}</span>
                            </div>
                            <!-- Due date on new row for small screens and lg screens -->
                            <div v-if="task.due_at" class="text-end mb-2">
                                <span class="text-muted small d-block d-sm-none">Due: {{ date(task.due_at) }}</span>
                                <span class="text-muted small d-none d-lg-block d-xl-none">Due: {{ date(task.due_at) }}</span>
                            </div>

                            <!-- Second row: description -->
                            <p class="mb-2 text-muted">{{ task.description }}</p>

                            <!-- Third row: View Task button -->
                            <a v-if="task.url" :href="task.url" :target="isExternalUrl(task.url) ? '_blank' : '_self'"
                                :rel="isExternalUrl(task.url) ? 'noopener noreferrer' : ''"
                                class="btn btn-primary mb-3"  style="width: 85px;">View
                                <!-- <i v-if="isExternalUrl(task.url)" class="fas fa-external-link-alt ms-1"
                                    style="font-size: 0.85em;"></i> -->
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import { useLockstepStore } from '../../stores/lockstep'

export default defineComponent({
    name: 'Tasks',
    data() {
        return {
            lockstepStore: useLockstepStore()
        };
    },
    methods: {
        // Create a function to use axios to call and endpoint to complete the task
        completeTask(task) {
            window.axios.post('/api/task/' + task.id + '/complete', {
                is_completed: true
            }).then(response => {
                // Update the task in the store to trigger reactivity
                this.lockstepStore.updateTask({
                    id: task.id,
                    is_completed: true
                });
            })
        },

        // Create a function to use axios to call and endpoint to unmark the task as complete
        unmarkTask(task) {
            window.axios.post('/api/task/' + task.id + '/complete', {
                is_completed: false
            }).then(response => {
                // Update the task in the store to trigger reactivity
                this.lockstepStore.updateTask({
                    id: task.id,
                    is_completed: false
                });
            })
        },
        
        // Check if URL is external (different domain)
        isExternalUrl(url) {
            if (!url) return false;
            try {
                const urlObj = new URL(url, window.location.origin);
                return urlObj.origin !== window.location.origin;
            } catch (e) {
                // If URL parsing fails, assume it's internal
                return false;
            }
        }
    }
}) 
</script>
